import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import SplashScreen from './components/SplashScreen';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Orion from './components/Orion';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import History from './pages/History';
import Projects from './pages/Projects';
import Testimonials from './pages/Testimonials';
import Contact from './pages/Contact';
import OrionChat from './pages/OrionChat';
import Slideshow from './pages/Slideshow';
import StrategySlideshow from './pages/StrategySlideshow';
export function App() {
  const [showSplash, setShowSplash] = useState(true);
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <AnimatePresence mode="wait" data-id="element-2">
        {showSplash ? <SplashScreen onComplete={() => setShowSplash(false)} data-id="element-3" /> : <div className="flex flex-col min-h-screen" data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/slideshow" element={<Slideshow data-id="element-7" />} data-id="element-6" />
              <Route path="/strategy" element={<StrategySlideshow data-id="element-9" />} data-id="element-8" />
              <Route path="*" element={<>
                    <Navbar data-id="element-11" />
                    <main className="flex-grow" data-id="element-12">
                      <Routes data-id="element-13">
                        <Route path="/" element={<Home data-id="element-15" />} data-id="element-14" />
                        <Route path="/servicios" element={<Services data-id="element-17" />} data-id="element-16" />
                        <Route path="/historia" element={<History data-id="element-19" />} data-id="element-18" />
                        <Route path="/proyectos" element={<Projects data-id="element-21" />} data-id="element-20" />
                        <Route path="/testimonios" element={<Testimonials data-id="element-23" />} data-id="element-22" />
                        <Route path="/ask-orion" element={<OrionChat data-id="element-25" />} data-id="element-24" />
                        <Route path="/contacto" element={<Contact data-id="element-27" />} data-id="element-26" />
                      </Routes>
                    </main>
                    <Footer data-id="element-28" />
                    <Orion data-id="element-29" />
                  </>} data-id="element-10" />
            </Routes>
          </div>}
      </AnimatePresence>
    </Router>;
}